import React from 'react';

const ChevronRight = ({ width = 24, height = 24 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={width} height={height} aria-hidden="true">
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
  </svg>
);

export default ChevronRight;
